import { FC, useState } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import CustomButton from "ui/Button";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { SettlementFilter } from "api/accounting";
import DatePickerComponent from "ui/Date";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: SettlementFilter) => void;
	filterOptions: SettlementFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();

	const [tempFilter, setTempFilter] = useState(filterOptions);

	const applySettlementNumber = () => {
		setFilterOptions({
			...filterOptions,
			// vesselLedgerAccountNumber: tempFilter.settlementNumber,
			settlementNumber: tempFilter.settlementNumber,
			take: props.pageSize,
			skip: 0,
		});
	};

	const settlementNumberValue =
		tempFilter.settlementNumber == null || tempFilter.settlementNumber === ""
			? null
			: Number(tempFilter.settlementNumber);

	return (
		<div className="filter-container">
			<div className="filter-items settlement-filter-items">
				{/* <div style={{ width: "170px" }}>
					<CustomInput
						onChange={(e) =>
							setTempFilter({ ...tempFilter, settlementNumber: e })
						}
						label={t("SettlementNumber")}
						placeholder=" "
						value={tempFilter.settlementNumber}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") applySettlementNumber();
						}}
						onBlur={(e) => applySettlementNumber()}
					/>
				</div> */}
				<div className="settlement-filter-field" style={{ width: "170px" }}>
					<NumericTextBox
						className="height-inherit"
						label={t("SettlementNumber")}
						placeholder=" "
						style={{ width: "100%" }}
						value={Number.isNaN(settlementNumberValue) ? null : settlementNumberValue}
						onChange={(e) =>
							setTempFilter({
								...tempFilter,
								settlementNumber:
									e.value == null ? undefined : String(e.value),
							})
						}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") applySettlementNumber();
						}}
						onBlur={() => applySettlementNumber()}
						spinners={false}
						format=""
					/>
				</div>
				<div className="settlement-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder=" "
						label={t("FromDate")}
						format={DATE_FORMAT}
						className="height-inherit"
						style={{ width: "100%" }}
						value={filterOptions.fromDate}
						onChange={(e) =>
							setFilterOptions({
								...filterOptions,
								fromDate: e.target.value,
								take: props.pageSize,
								skip: 0,
							})
						}
					/>
				</div>
					<div className="settlement-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder=" "
						label={t("ToDate")}
						className="height-inherit"
						format={DATE_FORMAT}
							style={{ width: "100%" }}
						value={filterOptions.toDate}
						onChange={(e) =>
							setFilterOptions({
								...filterOptions,
								toDate: e.target.value,
								take: props.pageSize,
								skip: 0,
							})
						}
					/>
				</div>
			</div>

				<div className="filter-end-btn settlement-filter-end-btn">
				{/*<CustomButton*/}
				{/*	label={"PDF"}*/}
				{/*	onClick={() => exportAsPDF()}*/}
				{/*	iconName={ICON_NAMES.Download}*/}
				{/*/>*/}
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
